export default __webpack_public_path__ + "static/media/mode-68.1c24ef70.svg";